<script lang="ts">
	import { Text, Alert, Input } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';

	export let value;
	export let action;
	export let isValid;
	export let onChange;

	let inputError: string = ''; // User input validation error

	$: input_val = typeof value != 'undefined' ? value : action?.config?.default_value || '';
	$: isValid = validateInput(input_val);
	$: max_len = action?.config?.max_len || 255;

	/**
	 * Handle user input change
	 * @param {string} val
	 */
	const handleChange = (val: string) => {
		input_val = val;
		onChange(input_val);
	};

	/**
	 * Validate user input and set error message if input is invalid
	 * @param {string} value
	 * @returns {bool} - true if input is valid
	 */
	const validateInput = (value: string): boolean => {
		let length = value.length;
		if (length > max_len) {
			inputError = $format('error_text_out_of_range', {
				default: `Value ({length} characters) is out of range. Please provide a value within the limits. ({min} — {max} characters)`,
				values: {
					length,
					min: 0,
					max: max_len,
				},
			});
			return false;
		}
		return true;
	};
</script>

<Text element="h2" class="mb-s mt-l"
	>{capFirstChar(
		action?.title ||
			$format('title_scene_set_property_value', {
				default: 'Set {property} to',
				values: { property: action.name },
			}),
	)}</Text
>
{#if action?.alert}
	<Alert class="mb-s" heading={action?.alert} type={'warning'} />
{/if}

<div class="d-flex mt-s">
	<Input
		aria-label={$format('input_value', { default: 'Value' })}
		size="m"
		icon={action?.icon}
		value={input_val}
		error={inputError}
		on:input={(e) => handleChange(e.target.value)}
		id="input-c7ihw1t"
	/>
</div>
